import { Typography } from "@mui/material";
import { MprcButton } from "components";
import { MprcSimpleDialog } from "components/MprcSimpleDialog";
import { PublicationActionResponse, PublicationType } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";


interface ModeratorMessageData {
    publicationId: string;
    publicationType: PublicationType;
    publicationTitle: string;
    masterPublicationId?: string;
    message?: string;
    actionResponse: PublicationActionResponse;
}

interface IProps {
    data: ModeratorMessageData;
    onClose: () => void;
}

export const ModeratorMessageDialog: React.FC<IProps> = (props) => {

    const { data: { publicationId, publicationType, publicationTitle, message, masterPublicationId, actionResponse }, onClose } = props;

    const { t } = useTranslation("shared");
    const navigate = useNavigate();

    return <MprcSimpleDialog
        title={t("Notifications.KnowledgeRequesterReportAnalysed.Title")}
        width="xs"
        subtitle={publicationTitle}
        message={
            <>
                {t("Notifications.KnowledgeRequesterReportAnalysed.DecisionText")}&nbsp;
                <Typography variant="overline" component="span">
                    {actionResponse == PublicationActionResponse.ReportIgnore
                        ? t("Notifications.KnowledgeRequesterReportAnalysed.RejectedText")
                        : t("Notifications.KnowledgeRequesterReportAnalysed.AcceptedText")
                    }
                </Typography>&nbsp;
                {t("Notifications.KnowledgeRequesterReportAnalysed.ByModeratorText")}

                {message &&
                    <>
                        <br />
                        <br />
                        {t("Notifications.KnowledgeRequesterReportAnalysed.ModeratorMessageText")}&nbsp;
                        "{message}"
                    </>
                }
            </>
        }
        actions={
            actionResponse != PublicationActionResponse.ReportExcludePublication &&
            <MprcButton
                variant="contained"
                title={t("Notifications.KnowledgeRequesterReportAnalysed.ViewPublicationButtonText")}
                onClick={() => navigate(KnowledgePaths.PublicationViewerResolver(publicationId, publicationType, masterPublicationId))}>
                {t("Notifications.KnowledgeRequesterReportAnalysed.ViewPublicationButtonText")}
            </MprcButton>
        }
        onClose={onClose}
    />;
};
